import React, { useEffect } from "react";
import { RouteAwareCrumbs } from "Components/shared/breadcrumbs";
import Text from "Components/shared/text";
import styles from './wallet.module.css';
import useForm from "hooks/useForm";
import Button from "Components/shared/button";
import { InputWithAdornment } from "Components/shared/inputs";
import { icons } from "assets";
import { Menu, MenuItem } from "Components/shared/menu";
import { Home } from "Components/main_components/wallet/swap_currency";

const SwapCurrency = (props) => {
      //Form Related States
      const initialState ={
        amount: '',
    }
    const submitHandler = (values,errors, setSubmitting, setErrors) => {

    }
    const {handleSubmit, values, errors, isSubmitting, isValid, touched, handleUpdate, setValues} = useForm({initialState, submitHandler});
    const NameMap = {
        "/wallet":"Wallet",
        "/wallet/swap-currency":"Swap Currency",
    }
    return (
        <div className={styles.root}>
            <div className={styles.Header}>
                <Text variant="lg" tag="h1" style={{fontWeight:"700"}}>Swap Currency</Text>
                <RouteAwareCrumbs nameMap={NameMap} />
            </div>
            <Home />
        </div>
    );
}



export default SwapCurrency;
